// extracted by mini-css-extract-plugin
export var changeIcon = "_5g-4";
export var container = "_5g-0";
export var divider = "_5g-7";
export var externalLinkIcon = "_5g-1";
export var green = "_5g-5";
export var helpCircleIcon = "_5g-3";
export var iconButton = "_5g-2";
export var red = "_5g-6";